export default __webpack_public_path__ + "static/media/02n.5263fa8a.jpg";